import RESTProvider from './RESTProvider';

export type { Props as RESTProviderProps } from './RESTProvider';

export { RESTProvider } from './RESTProvider';
export { useREST } from './RESTProvider';

export default RESTProvider;
